import type { Router } from "vue-router";
import { checkUserHasRight } from "@/router/guards/checkUserHasRight";
import { checkVersion } from "@/router/guards/checkVersion";
import { handleInvalidTokenFound } from "@/router/guards/handleInvalidTokenFound";
import { handleItemEditationAccess } from "@/router/guards/handleItemEditationAccess";
import { handleLogin } from "@/router/guards/handleLogin";
import { handleRedirectForLoggedInUser } from "@/router/guards/handleRedirectForLoggedInUser";
import { RouteName } from "@/router/routeNameEnum";
import { setLinkAlternate } from "@/router/guards/setLinkAlternate";
import { setUserPreferredLocalization } from "@/router/guards/setUserPreferredLocalization";
import { startupUserCheck } from "@/router/guards/startupUserCheck";
import { storeLocalizationInApp } from "@/router/guards/storeLocalizationInApp";
import { Right } from "@/services/user/userTypes";
import { registerDynamicImportRecovery } from "@/router/dynamicImportRecovery";

export function registerGuards(router: Router): void {
  router.beforeEach(startupUserCheck);
  router.beforeEach(checkVersion);
  router.beforeEach(storeLocalizationInApp);
  router.beforeEach(handleInvalidTokenFound);
  router.beforeEach(setUserPreferredLocalization);
  router.beforeEach(handleLogin);
  router.beforeEach(handleRedirectForLoggedInUser);
  router.beforeEach(handleItemEditationAccess);
  router.beforeEach(checkUserHasRight(RouteName.YearInReview, Right.YearInReview));

  router.afterEach(setLinkAlternate);

  registerDynamicImportRecovery(router);
}
